// @ts-nocheck
import {createSlice} from "@reduxjs/toolkit";

const slice = createSlice({
    name: "app",
    initialState: {},
});

export default slice.reducer;
